module.exports = __webpack_public_path__ + "static/img/face_top.png";